module.exports = __webpack_public_path__ + "src/assets/img/sunny.fe09b5c6.svg";